<template>
  <div class="main">
    <date></date>
    <div class="headerTop"></div>
    <backBtn></backBtn>
    <div class="activeTitle" style="margin-top: 60px">业主诉求</div>

    <div class="banner">
      <div class="tabs">
        <div class="tabspan" @click="handlerDialog('业主诉求流程', '50%', 1)">
          <img style="
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 10px;
            " src="../../assets/images/ico_btn@2x.png" alt="" />业主投诉流程
        </div>
        <div @click="handlerDialog('办事指南', '80%', 2)" class="tabspan1">
          <img style="
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 10px;
            " src="../../assets/images/ico_btn_3@2x.png" alt="" />办事指南
        </div>
      </div>
    </div>


    <div class="toushu">
      <div class="systemTitle" style="width: 50%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;诉求记录
        <div style="margin-top: 10px"></div>
      </div>
      <toushuTbale></toushuTbale>
    </div>

    <!-- 图表 -->

    <div class="echarts">
      <div class="qushi">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近六个月业主诉求增量趋势
        </div>
        <div class="line" id="line"></div>
      </div>
      <div class="fenbu">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业主诉求楼栋分布
        </div>
        <div class="bar" id="bar"></div>
      </div>
    </div>

    <div class="echarts">
      <div class="qushi">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业主评价分值情况
        </div>
        <div class="bar2" id="bar2"></div>

      </div>
      <div class="fenbu">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业主诉求来源分类统计
        </div>
        <div class="line2" id="line2"></div>
      </div>
    </div>


    <el-dialog :visible.sync="dialogVisible" width="80%">
      <div class="dialog_title">{{ dialogTitle }}</div>
      <!-- <div class="container" v-if="dialogTitle == '报事报修指南'">
        <p>一、职责</p>
        <p>
          1、物业客服中心负责客户报修的接收工作。根据报修内容认真填写《报修单》。详细记录时间，地点和报修人的联系方式。工作中负责协助并跟进报修项目的维修进展情况。
        </p>
        <p>
          2、工程部库房管理人员及各专业主管负责人参与制定维修计划，备材质量监督维修施工质量。负责维修施工后验收和回访工作。
        </p>
        <p>
          3、工程部内勤管理人员负责接收《报修单》，并通知维修班领班及工程部相关主管人员，工程部专业主管人员根据报修内容和实际现场情况制定维修方案和工作计划。维修班领班指令专业维修人员维修，施工并监督维修施工质量。维修班主管人员或各专业主管负责人负责维修施工后的验收工作。
        </p>
        <p>
          4、维修中心维修人员负责报修内容的确认，根据实际维修情况协助主管领导制定维修计划。按时，按质，按量完成《报修单》并详细记录在案。
        </p>
        <p>二、工作流程</p>
        <p>1、客服中心接到报修后，根据报修内容及时填写报修单报送至工程部。</p>
        <p>
          2、接报修人员根据实际报修内容情况将《报修单》转交相关专业主管人员或维修班主管人员。
        </p>
        <p>
          3、维修班领班根据《报修单》内容情况安排专业维修人员前往报修地点工作。
        </p>
        <p>
          3.1如报修情况紧急，维修人员接到维修指令后，第一时间赶往现场处理工作。
        </p>
        <p>
          4、维修人员在工作中要按时，按质完成工作。工作完成后认真填写《报修单》并请报修人确认并签署维修意见。
        </p>
        <p>
          5、维修人员返回公司后将维修工作情况和《报修单》反馈给工程部接报修负责人并详细记录在案。
        </p>
        <p>
          6、维修班或各主管负责人审核维修质量确认完成后将《报修单》和维修内容反馈给接报修负责人。
        </p>
        <p>
          7、客服中心负责回访报修内容，各专业主管人员确认维修施工质量并将《报修单》记录在案。
        </p>
        <p>8、至此工作结束。</p>
      </div>
      <div v-else>
        <img
          style="width: 90%; height: 700px; margin: 20px 40px"
          src="../../assets/images/flowable.png"
          alt=""
        />
      </div> -->

      <div v-html="zsnr" class="zsnrcontent"></div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import date from "../../components/header/index.vue";

import accountTable from "../Table/accountTable.vue";
import toushuTbale from "../Table/toushuTbale.vue";
import backBtn from "../../components/back/index.vue";
import api from "@/api/repair.js";
export default {
  name: "",
  components: { accountTable, toushuTbale, backBtn, date },
  data() {
    return {
      dialogVisible: false,
      colors1: [{ color: "#4D9CFF", percentage: 20 }],
      colors2: [{ color: "#5CFF4D", percentage: 20 }],
      option: {
        legend: {
          data: ["诉求量"],
          right: "40px",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
          ],
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#FFFFFF",
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#FFFFFF",
            },
          },
        },
        series: [
          {
            // name: "诉求量",
            data: [
              42757, 57229, 543099.14, 175077.44, 183865, 391134.1, 731313,
              784579,
            ],
            type: "line",
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#37EBFF",
                },
                {
                  offset: 1,
                  color: "rgba(0,0,0, 0.1)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#37EBFF",
              },
            },
          },
        ],
      },

      option2: {
        legend: {
          data: ["诉求量"],
          right: "40px",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "2015",
            "2016",
            "2017",
            "2018",
            "2019",
            "2020",
            "2021",
            "2022",
          ],
          axisLabel: {
            interval: 0,
            
            textStyle: {
              color: "#FFFFFF",
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },
          axisLabel: {
            margin: 50,
            textStyle: {
              color: "#FFFFFF",
            },
          },
        },
        series: [
          {
            // name: "诉求量",
            data: [
              42757, 57229, 543099.14, 175077.44, 183865, 391134.1, 731313,
              784579,
            ],
            type: "bar",
            barWidth: "50px",
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#37EBFF",
                },
                {
                  offset: 1,
                  color: "rgba(0,0,0, 0.1)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#37EBFF",
              },
            },
          },
        ],
      },
      option1: {
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "1%",
          containLabel: true,
        },
        legend: {
          data: [],
          bottom: "0",
          textStyle: {
            color: "#fff",
          },
        },

        series: [
          {
            type: "pie",
            radius: "50%",
            data: [],
            label: {
              formatter: function (pram) {
                // return "{a|" + pram.data.value + " " + pram.percent + "% }";
                return "{a|" + pram.percent + "% }";
              },
              padding: [0, -100, 20, -100], //关键代码！关键代码！关键代码！
              rich: {
                a: {
                  fontSize: 14,
                  color: "#fff",
                  fontWeight: 500,
                  lineHeight: 32,
                  align: "right",
                },
              },
            },
            labelLine: {
              normal: {
                length: 20,
                length2: 150, // 指示线宽度
                lineStyle: {
                  color: "#fff", // 指示线颜色
                },
              },
            },

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      dialogTitle: "",
      dialogWidth: "",
      zsnr: "",
    };
  },
  created() { },
  mounted() {
    this.initEcharts();
    this.initEcharts2();
    this.initBar();
    this.initBar2();
  },
  methods: {
    format(percentage) {
      return percentage ? `${percentage}` : `${percentage}`;
    },
    initEcharts() {
      var chartDom = document.getElementById("line");
      var myChart = echarts.init(chartDom);
      api.bxqs().then((res) => {
        if (res.data.code == 200) {
          let xAxis = [];

          let datas = [];
          res.data.data.forEach((item) => {
            xAxis.push(item.sj);
            datas.push(item.tsl);
          });
          this.option.xAxis.data = xAxis;
          this.option.series[0].data = datas;
          myChart.setOption(this.option);
        }
      });
    },
    // 业主分值情况
    initEcharts2() {
      var chartDom = document.getElementById("line2");
      var myChart = echarts.init(chartDom);
      api.lyqk().then((res) => {

        if (res.data.code == 200) {
          let xAxis = ["电话", "网络", "用户", "老年服务", "其它"];
          let datas = [];
          res.data.data.forEach((item) => {
            if (item.lzmc == '1') {
              datas[0] = item.sl;
            }
            if (item.lzmc == '2') {
              datas[1] = item.sl;
            }
            if (item.lzmc == '3') {
              datas[2] = item.sl;
            }
            if (item.lzmc == '5') {
              datas[3] = item.sl;
            }
            if (item.lzmc == '4') {
              datas[4] = item.sl;
            }
          });
          let option = JSON.parse(JSON.stringify(this.option2));
          option.xAxis.data = xAxis;
          option.series[0].data = datas;
          myChart.setOption(option);
        }
      });
    },


    initBar() {
      var chartDom = document.getElementById("bar");
      var myChart = echarts.init(chartDom);
      api.bxldfb().then((res) => {
        if (res.data.code == 200) {
          let names = [];
          let datas = [];
          res.data.data.forEach((item) => {
            let obj = {};
            obj.name = item.lzmc;
            obj.value = (item.fbzb * 100).toFixed(2);
            datas.push(obj);
            names.push(item.lzmc);
          });
          this.option1.legend.data = names;
          this.option1.series[0].data = datas;
          myChart.setOption(this.option1);
        }
      });
    },

    initBar2() {
      var chartDom = document.getElementById("bar2");
      var myChart = echarts.init(chartDom);
      api.fzqk().then((res) => {


        if (res.data.code == 200) {
          let names = [];
          let datas = [];
          res.data.data.forEach((item) => {
            let obj = {};
            obj.name = item.lzmc;
            obj.value = (item.fbzb / 100).toFixed(2);
            datas.push(obj);
            names.push(item.lzmc);
          });

          let option1 = JSON.parse(JSON.stringify(this.option1));
          option1.legend.data = names;
          option1.series[0].data = datas;

          console.log(option1, 44444)


          myChart.setOption(option1);
        }
      });
    },

    handlerDialog(title, width, type) {
      api
        .getInfo({
          zslx: type,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.dialogVisible = true;
            this.dialogTitle = title;
            this.dialogWidth = width;
            this.zsnr = decodeURIComponent(res.data.data.zsnr);
          } else {
            this.$message.warning("暂无数据");
          }
        });
    },

    //时分秒
    formatSeconds(value) {
      let result = parseInt(value) / 1000;
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);

      let res = "";
      if (h !== "00") res += ` ${h} h`;
      if (m !== "00") res += ` ${m} m`;
      res += ` ${s} s`;
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.zsnrcontent {
  height: 650px;
  overflow-y: scroll;
  margin-top: 30px;

  &::-webkit-scrollbar {
    width: 1px;
  }
}

.banner {
  height: 104px;
  border-radius: 16px;
  border: 1px solid #005070;
  margin: 40px 0;

  .tabs {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;

    .tabspan {
      width: 48%;
      height: 55px;
      line-height: 55px;
      background: linear-gradient(135deg, #098ea8 0%, #1fb28d 100%);
      border-radius: 204px;
      border: 2px solid rgba(83, 255, 226, 0.6588);
      cursor: pointer;
      margin-top: 20px;
    }

    .tabspan1 {
      width: 48%;
      line-height: 55px;
      height: 56px;
      background: linear-gradient(135deg, #3479d0 2%, #2c98bc 100%);
      border-radius: 204px;
      border: 2px solid #1bd9ff;
      cursor: pointer;
      margin-top: 20px;
    }
  }
}

.service {
  display: flex;

  .service_left {
    // flex: 1;
    margin-right: 20px;
  }

  .service_right {
    flex: 2;
    height: 420px;
    background: linear-gradient(154deg,
        rgba(0, 132, 255, 0.66) 0%,
        rgba(62, 126, 246, 0) 100%);
    border: 2px solid #70e2ee;
    border-radius: 24px;

    // border-image: linear-gradient(
    //     136deg,
    //     rgba(111.77069842815399, 225.65026849508286, 238.30357432365417, 1),
    //     rgba(28.000000230968, 46.000001057982445, 69.00000348687172, 1),
    //     rgba(79.06289711594582, 116.98736250400543, 165.44643580913544, 1)
    //   )
    //   2 2;
    padding: 20px;
  }
}

.total {
  display: flex;

  .repair {
    width: 142px;
    height: 160px;
    margin-right: 20px;
    background: url("../../assets/images/img_databg_blue@2x.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
  }

  .tousu {
    width: 142px;
    height: 160px;
    background: url("../../assets/images/img_databg_green@2x.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
  }
}

.repair_time {
  width: 266px;
  height: 85px;
  background: url("../../assets/images/img_databg_blue2@2x.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 20px;
  padding: 20px 10px 20px 30px;
}

.tousu_time {
  width: 266px;
  height: 85px;
  background: url("../../assets/images/img_databg_green2@2x.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 20px;
  padding: 20px 10px 20px 30px;
}

::v-deep .el-progress__text {
  color: #fff;
}

.toushu {
  height: 460px;
  margin-top: 20px;
  background: linear-gradient(154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%);
  border-radius: 24px;
  border: 2px solid #70e2ee;

  padding: 20px 20px 5px 20px;
}

.echarts {
  display: flex;
  margin-top: 20px;

  .qushi {
    flex: 1;
    height: 410px;
    padding: 20px;
    background: linear-gradient(154deg,
        rgba(0, 132, 255, 0.66) 0%,
        rgba(62, 126, 246, 0) 100%);
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    border: 2px solid #70e2ee;

  }

  .fenbu {
    flex: 1;
    height: 410px;
    padding: 20px;
    background: linear-gradient(154deg,
        rgba(0, 132, 255, 0.66) 0%,
        rgba(62, 126, 246, 0) 100%);
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    border: 2px solid #70e2ee;
    margin-left: 20px;
  }
}

.line,
.line2 {
  width: 100%;

  height: 359px;
}

.bar,
.bar2 {
  width: 100%;
  height: 359px;
}

.duration {
  font-weight: 500;
  font-size: 24px;
  font-family: "barlownumber";
}

.dialog {
  // height: 800px;
  background: linear-gradient(154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%);
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
}

::v-deep .el-dialog {
  // height: 800px;
  background: url("../../assets/images/dialog_bg2.png");
  background-size: 100% 100%;
  border-radius: 24px;

  color: #fff;
  position: relative;
  overflow: hidden;
}

::v-deep .el-dialog h1 {
  font-size: 26px;
  color: #001742;
}

::v-deep .el-dialog h2 {
  color: #001742;
}

::v-deep .el-dialog p {
  text-indent: 2em;
  color: #fff;
  font-size: 18px;
  padding: 0 20px;
  line-height: 29px;
}

::v-deep .el-dialog__title {
  color: #001742;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 24px;
}

.dialog_title {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  min-width: 285px;
  height: 46px;
  color: #fff;
  background-size: 100% 100%;
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  line-height: 46px;
  margin-top: 20px;
}

.container {
  height: 650px;
  overflow-y: scroll;
  margin-top: 30px;
}
</style>
